// Keys used in localstorage
export const STORED_LANGUAGE = window?.__RUNTIME_CONFIG__?.REACT_APP_TENANT_ID + '_selectedVingo2Language';
export const STORED_AUTH_TOKEN: string = window?.__RUNTIME_CONFIG__?.REACT_APP_TENANT_ID + '_auth_token';
export const STORED_AUTH_SAMLNAMEID: string = window?.__RUNTIME_CONFIG__?.REACT_APP_TENANT_ID + '_samlnameid';
export const STORED_AUTH_SESSIONINDEX: string = window?.__RUNTIME_CONFIG__?.REACT_APP_TENANT_ID + '_sessionindex';
export const STORED_COMPANY_INFO: string = window?.__RUNTIME_CONFIG__?.REACT_APP_TENANT_ID + '_company_Info';
